import { BasePhoneVerification } from '@/pages/SignInSignUp/PhoneNumberAddVerification/BasePhoneVerification';
import { memo, useState } from 'react';

interface PhoneVerificationModalProps {
  email: string;
  phoneNumber: string;
  isNewAccount?: boolean;
  onVerificationComplete: (phoneNumber: string, verificationId: string, verificationCode: string) => Promise<void>;
  onSwitchToEmail?: () => void;
}

const maskPhone = (phone: string) => {
  const digits = phone.replace(/\D/g, '');
  const last4 = digits.slice(-4) || phone;
  return `*** *** ${last4}`;
};

export const PhoneVerificationModal = memo(
  ({ phoneNumber,  onVerificationComplete, onSwitchToEmail}: PhoneVerificationModalProps) => {
    const [hasError, setHasError] = useState(false);

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4">
        <div className="w-full max-w-xl rounded-lg bg-white p-6 text-black shadow-xl">
          <h2 className="text-2xl font-semibold text-center">
            Verify your account
          </h2>
          <p className="mt-2 text-sm text-center text-gray-700">
            Please verify your phone number to continue.
          </p>
          <div className="mt-4">
            <BasePhoneVerification
              customContainerClassName="items-center"
              phoneNumber={phoneNumber}
              spinnerDarkMode={false}
              onVerificationComplete={onVerificationComplete}
              onError={() => setHasError(true)}
              verificationCodeHeader={({phoneNumber}) => (
                <p className="text-base text-gray-700 text-center">
                  A verification code was sent to {maskPhone(phoneNumber)}
                </p>
              )}
            />
          </div>
          {hasError && onSwitchToEmail && (
            <div className="mt-4 pt-4 border-1 border-t border-gray-200">
              <p className="text-sm text-gray-600 text-center mb-3">
                Having trouble with phone verification?
              </p>
              <button
                className="w-full rounded-md bg-primary py-2 text-white text-base font-semibold hover:opacity-90"
                onClick={onSwitchToEmail}
              >
                Verify via email instead
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
);

PhoneVerificationModal.displayName = 'PhoneVerificationModal';
